/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddSkillRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/skills_messages.pb'
import {AddSkillResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/skills_messages.pb'


export const addSkill = (request: AddSkillRequest, options?: CashRequestOptions) => post<AddSkillRequest, AddSkillResponse>("/2.0/cash/add-skill", request, {...options, rejectOnError: true })